import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export interface LoadingRef {
    show: (modal: boolean) => void;
    hide: () => void;
}

export default React.forwardRef<LoadingRef, {}>(function Loading(_, ref) {
    const {0: status, 1: setStatus} = React.useState(false);
    const {0: modal, 1: setModal} = React.useState(false);
    React.useImperativeHandle(ref, () => ({
        show: (modal) => {
            setModal(modal);
            setStatus(true);
        },
        hide: () => setStatus(false)
    }), [status, modal]);
    return status ? (
        <>
            {modal ? (<div className="loading-mask" />) : null}
            <div className="loading global">
                <FontAwesomeIcon icon={faSpinner} spin className="text-white" />
            </div>
        </>
    ) : null;
});